import { create } from 'zustand';

const useSupportStore = create((set) => ({
    formData: {
        name: '',
        email: '',
        category: 'Feedback',
        message: ''
    },
    isOpen: false,
    isMinimized: false,
    
    setFormData: (data) => set((state) => ({ 
        formData: { ...state.formData, ...data } 
    })),
    
    resetForm: () => set({
        formData: {
            name: '',
            email: '',
            category: 'Feedback',
            message: ''
        }
    }),
    
    toggleOpen: () => set((state) => ({ isOpen: !state.isOpen })),
    setMinimized: (minimized) => set({ isMinimized: minimized }),
}));

export default useSupportStore;
